import React from "react";

export default function SiteLogo() {
    return <h1>ATLAN FE</h1>;
}
